
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Signin from './components/Signin';
import Signup from './components/Signup';
// eslint-disable-next-line no-unused-vars
import MainPage from './components/MainPage';
import Admin from './components/Admin';
import UnderConstruction from './components/UnderConstruction/UnderConstruction';

// Set to `false` to take the site live (restores MainPage on `/`).
const UNDER_CONSTRUCTION = true;

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/signin" element={<Signin />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/admin" element={<Admin />} />
        <Route
          path="/"
          element={UNDER_CONSTRUCTION ? <UnderConstruction /> : <MainPage />}
        />
        {UNDER_CONSTRUCTION && (
          <Route path="*" element={<Navigate to="/" replace />} />
        )}
      </Routes>
    </Router>
  );
};

export default App;
